module.exports = __webpack_public_path__ + "static/gni-logo-f5b619f9e524101a679c186f3c9c16c6.png";